import Vue from 'vue'
import Router from 'vue-router'


// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')
const Register = () => import('@/views/pages/Register')

const Document = () => import('@/views/Documents/document/index')
const EditDocument = () => import('@/views/Documents/document/edit')

const Main = () => import('@/views/Main/main/index')


Vue.use(Router)

const router =  new Router({
  mode: 'history', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function configRoutes () {
  return [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: TheContainer,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: '/Documents',
          redirect: "/Documents/Document",
          name: "Documents",
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'Document',
              name: 'Document',
              component: Document,
              props: {
                typeid: 1
              }
            },
            {
              path: 'Document/edit/id=:id',
              name: 'EditDocument',
              component: EditDocument,
              props: {
                typeid: 1
              }
            },
    
          ]
        },
        {
          path: '/Main',
          redirect: "/Main/Main",
          name: "Main",
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'Main',
              name: 'Main',
              component: Main,
             
            },
          ],
        },
      ]
    },
    
    {
      path: '*',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        },
        {
          path: 'login',
          name: 'Login',
          component: Login
        },
        {
          path: 'register',
          name: 'Register',
          component: Register
        }
      ]
    }
  ]
}
router.beforeEach((to, from, next) => {
  if(to.path != '/login') {
    if(localStorage.getItem('auth_token')) { 
        
        next();
    } else {
        
        next('login');
    }
} else {
    
    next(); 
}
})
export default router


